<div class="circle-mark" [style.backgroundColor]="params?.colorCode"></div>
